import {BehaviorSubject, Observable} from "rxjs";
import {clone} from "./common";

export class StateService<T> {
  empty: T | null = null;
  protected stateItem: BehaviorSubject<T | null> = new BehaviorSubject(this.empty);
  stateItem$: Observable<T | null> = this.stateItem.asObservable();

  get currentItem(): T | null {
    return this.stateItem.getValue();
  }

  SetState(item: T) {
    this.stateItem.next(item);
  }

  UpdateState(item: Partial<T>) {
    const newItem = {...this.currentItem, ...clone(item)};
    this.stateItem.next(newItem);
  }

  RemoveState(): void {
    this.stateItem.next(null);
  }

}
